export default __webpack_public_path__ + "static/media/facebook.5e19df6c.svg";